import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-forward',
  templateUrl: './mobile-forward.component.html',
  styleUrls: ['./mobile-forward.component.less'],
})
export class MobileForwardComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = userAgent.includes('android');
    const isIOs = userAgent.includes('iphone');

    if (isAndroid) {
      window.location.replace(
        'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=io.zeuslabs.driver',
      );
    }
    if (isIOs) {
      window.location.replace('https://apps.apple.com/us/app/zeus-driver/id1525868694');
    }

    // TODO: Add appStore forward when it get available
  }
}
